import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './CityInput.css';

function CityInput({ onSearch, loading }) {
  const [city, setCity] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch(city);
  };

  return (
    <form onSubmit={handleSubmit} className="city-input-form">
      <div className="input-line">
        <span className="prompt">user@cyber:~$</span>
        <span className="command">./get_weather --city</span>
      </div>
      
      <div className="input-field-container">
        <span className="input-prompt">&gt;</span>
        <input
          type="text"
          value={city}
          onChange={(e) => setCity(e.target.value)}
          placeholder="MOSCOW"
          className="city-input"
          disabled={loading}
          autoFocus
        />
        <motion.button
          type="submit"
          className="submit-btn"
          disabled={loading || !city.trim()}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          [ENTER]
        </motion.button>
      </div>
      
      <div className="input-hint">
        * города вводить латиницей (например: London, Paris, Tokyo)
      </div>
    </form>
  );
}

export default CityInput;